const UserStatus = {
  Active: "active",
  Deactivated: "deactivated",
  Deleted: "deleted",
};
  
export default UserStatus;